import urlTemplate from 'url-template';

var archivePartnerLink = function archivePartnerLink() {
  var mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return urlTemplate.parse("".concat(mpacBaseUrl, "/archive/vendors/{partnerId}"));
};

var appDetailsLink = function appDetailsLink() {
  var mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return urlTemplate.parse("".concat(mpacBaseUrl, "/plugins/{appKey}/overview"));
};
/**
 * Contains templatized paths for marketplace resources
 */


var defaultLinkTemplate = {
  expand: function expand() {
    return '';
  }
};

var linkTemplates = function linkTemplates(_ref) {
  var mpacBaseUrl = _ref.mpacBaseUrl,
      mpacCdnBaseUrl = _ref.mpacCdnBaseUrl,
      macBaseUrl = _ref.macBaseUrl,
      wacBaseUrl = _ref.wacBaseUrl,
      atlassianCommunityBaseUrl = _ref.atlassianCommunityBaseUrl;
  return {
    appDetails: appDetailsLink(mpacBaseUrl),
    appPricingDetails: urlTemplate.parse(mpacBaseUrl + '/plugins/{appKey}/pricing'),
    mediaFile: urlTemplate.parse(mpacCdnBaseUrl + '/files/{imageId}'),
    appHostingDetails: urlTemplate.parse(mpacBaseUrl + '/plugins/{appKey}/{hosting}/overview'),
    appIcon: urlTemplate.parse(mpacBaseUrl + '/plugins/{appKey}/icon'),
    appRating: urlTemplate.parse(mpacBaseUrl + '/plugins/{appKey}/reviews'),
    appManageLink: urlTemplate.parse(mpacBaseUrl + '/manage/apps/{appId}'),
    appShortLink: urlTemplate.parse(mpacBaseUrl + '/{appId}'),
    managePrivateListing: urlTemplate.parse(mpacBaseUrl + '/manage/apps/{appId}/private-listings'),
    partnerDetails: urlTemplate.parse(mpacBaseUrl + '/vendors/{id}/{slug}'),
    appCreateCommunityQuestionLink: urlTemplate.parse("".concat(atlassianCommunityBaseUrl, "/t5/custom/page/page-id/create-post-step-1?add-tags=atlassian-marketplace,addon-{appKey},{hosting}")),
    appVersionHistory: urlTemplate.parse(mpacBaseUrl + '/apps/{appId}/{appSlug}/version-history'),
    artifactDownload: urlTemplate.parse(mpacBaseUrl + '/download/apps/{appId}/version/{buildNumber}'),
    descriptorDownload: urlTemplate.parse(mpacBaseUrl + '/download/apps/{appId}/version/{buildNumber}/descriptor'),
    appListingCanonical: urlTemplate.parse("".concat(mpacBaseUrl, "/apps/{appId}/{slug}")),
    appListing: urlTemplate.parse("".concat(mpacBaseUrl, "/apps/{appId}/{slug}?hosting={hosting}&tab={tab}")),
    trialLicenseActivation: macBaseUrl ? urlTemplate.parse(macBaseUrl + '/addon/try/{hamsAppKey}') : defaultLinkTemplate,
    licensePurchase: wacBaseUrl ? urlTemplate.parse(wacBaseUrl + '/purchase/addon/{hamsAppKey}') : defaultLinkTemplate
  };
};

var managePartnerTabRoutes = function managePartnerTabRoutes() {
  return {
    apps: urlTemplate.parse('/manage/vendors/{partnerId}/addons'),
    details: urlTemplate.parse('/manage/vendors/{partnerId}/details'),
    contacts: urlTemplate.parse('/manage/vendors/{partnerId}/contacts'),
    promotions: urlTemplate.parse('/manage/vendors/{partnerId}/promos'),
    security: urlTemplate.parse('/manage/vendors/{partnerId}/security'),
    reports: urlTemplate.parse('/manage/vendors/{partnerId}/reporting/sales?period=past90Days'),
    admin: urlTemplate.parse('/manage/vendors/{partnerId}/admin')
  };
};

var promotionDetailsTabRoutes = function promotionDetailsTabRoutes() {
  return {
    details: urlTemplate.parse('/manage/vendors/{partnerId}/promos/{promotionId}/details'),
    codes: urlTemplate.parse('/manage/vendors/{partnerId}/promos/{promotionId}/codes'),
    pricing: urlTemplate.parse('/manage/vendors/{partnerId}/promos/{promotionId}/pricing')
  };
};

var manageAppsTabRoutes = function manageAppsTabRoutes() {
  return {
    appPricing: urlTemplate.parse('/manage/apps/{appKey}/pricing')
  };
};

export { appDetailsLink, archivePartnerLink, linkTemplates, manageAppsTabRoutes, managePartnerTabRoutes, promotionDetailsTabRoutes };